var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSafePal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 92,
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 92,
    height: 92,
    rx: 16,
    fill: "#4A21EF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10023_6521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.304 16C40.48 16 38.728 16.72 37.432 18.016L17.152 38.296C16.384 39.064 16 40.072 16 41.08C16 42.088 16.384 43.096 17.152 43.864L30.448 57.16V33.64C30.448 31.888 31.864 30.472 33.616 30.472C41.032 30.472 59.104 30.472 61.552 30.472L76 16.024H42.304V16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.448 61.5518H58.384C60.136 61.5518 61.552 60.1358 61.552 58.3838V34.8638L74.848 48.1598C75.616 48.9278 76 49.9358 76 50.9438C76 51.9518 75.616 52.9598 74.848 53.7278L54.568 74.0078C53.272 75.3038 51.52 76.0238 49.696 76.0238H16L30.448 61.5758V61.5518Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10023_6521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafePal);
export default __webpack_public_path__ + "static/media/SafePal.f34060bb0326c01de3721ee78a201c96.svg";
export { ForwardRef as ReactComponent };